module.exports = __webpack_public_path__ + "static/media/010book_in2.5274cf15.png";